import show_details from "./components/show_details";
show_details();

import type_fields from "./components/type_fields";
import phone_mask from "./components/phone_mask";

import modals from "./components/modals";
modals();

import tabs from "./components/tabs";
import tabs_mobile from "./components/tabs_mobile";

tabs();
tabs_mobile();

import accordion from "./components/accordion";
accordion();
// whatTabs();
// window.addEventListener("resize", whatTabs);

// function whatTabs() {
//   let width = document.documentElement.clientWidth;

//   if (width <= 1024) {
//     tabs_mobile();
//   } else {
//     tabs();
//   }
// }
